/* istanbul ignore file */
import React from 'react';
import type { Data } from 'framework/types';
import { NOTE_TAG_ALIAS } from 'domain/recruiting/candidate/Timeline/shared/input/CandidateNoteTagDropdown';

type CandidateNoteTagProps = {
  entity: Data;
};

const CandidateNoteTag = ({ entity }: CandidateNoteTagProps) => {
  const tag: keyof typeof NOTE_TAG_ALIAS = entity.getValueBySource('tag');
  const displayedTag = NOTE_TAG_ALIAS[tag];

  if (!displayedTag) {
    return null;
  }

  return (
    <div className="note-tag">
      <i className="fa fa-star" aria-hidden style={{ marginRight: 0.5 }} />
      {displayedTag}
    </div>
  );
};

export default CandidateNoteTag;
